import React from 'react'
import Layout from '../components/Layout'
import ReactMarkdown from 'react-markdown'
import ArticleAPI from '../api/ArticleAPI'
import Container from 'react-bootstrap/Container'
import Footer from '../components/Footer'
import ReactPlayer from 'react-player'
import ReactGA from 'react-ga'
import { print } from '../managers/Logger'
import Button from 'react-bootstrap/Button'
import moment from 'moment'
import constants from '../components/Constants'
import { getSelectorsByUserAgent } from 'react-device-detect'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FiShare } from 'react-icons/fi'
import Head from 'next/head'
import NoSSR from 'react-no-ssr'
import MetricsManager from '../managers/MetricsManager'
import DownloadPlug from '../components/DownloadPlug'
export default class Story extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			input: "Awesome story here.."
		}

		this.metricsManager = new MetricsManager()
	}


	componentDidMount() {
		ReactGA.initialize('UA-139931598-1')
		ReactGA.pageview(window.location.pathname + window.location.search);
		ReactGA.event({
			category: 'Story',
			action: 'view',
			label: 'story_page',
			value: this.props.article.id
		})
		if (this.props.article.title == undefined || this.props.article == null) {
			return null
		}
		print(this.props.article)
		const str = this.props.article.title.replace(/\s+/g, '-').toLowerCase();
		window.history.replaceState({}, "", "/blog/" + str + "-" + this.props.article.id)
		new ClipboardJS('.btn');
	}

	Image(props) {
		return <img {...props} style={{ maxWidth: '100%', maxHeight: '600px' }} />
	}

	static async getInitialProps(context) {
		var id = context.query.id
		const regex = /(\d+$)/
		var matches = id.match(regex);

		if (matches !== null && matches !== undefined && matches.length !== 0) {
			id = matches[0]
		}

		if (id == undefined || id == null) {
			return {}
		} else {
			const articleAPI = new ArticleAPI()
			const article = await articleAPI.getById(id)
			const data = {}
			if (article.category !== "automated_event_list") { 
				data.excludeCategory = ['automated_event_list']
			}
			
			const otherArticles = await articleAPI.getStories(null, data);

			return { article: article, otherArticles: otherArticles }
		}
	}

	getVideo() {
		if (this.props.article.video_url != undefined && this.props.article.video_url != null && this.props.article.video_url != '') {
			return (
				<div style={{ justifyContent: 'center', marginBottom: 20 }}>
					<ReactPlayer url={this.props.article.video_url}
						controls={true}
						width="100%"
					/>
				</div>)
		}
	}

	getLargeImage() {
		if (this.props.article.video_url == undefined || this.props.article.video_url == null || this.props.article.video_url === '') {
			return <div style={{
				backgroundImage: `url(${this.props.article.image_url})`,
				width: '100%',
				height: '400px',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				diplay: 'flex',
				marginBottom: '20px'
			}}>
			</div>
		}
	}

	handleShare() { 
		if (window.navigator.share) {
			window.navigator.share({
				url: window.location.href, 
				title: this.props.article.title,
				text: this.props.article.title
			})
		} else { 
			alert("Article copied!");
		}
		this.metricsManager.logEvent("blog_share", {id: this.props.article.id});
	}

	render() {
		const source = this.props.article.content.replace(/\/SPACE/gi, '\n &nbsp;');
		const deviceInfo = getSelectorsByUserAgent(this.props.userAgent);
		return (
			<Layout
				title={this.props.article.title}
				description={this.props.article.subheading}
				imageUrl={this.props.article.image_url}
				noContainer
				style={{ backgroundColor: 'white', paddingBottom: 20 }}>
				<Head>
					<script src="https://cdn.jsdelivr.net/npm/clipboard@2/dist/clipboard.min.js"></script>
				</Head>
				{/* <DownloadPlug simple id="blog"></DownloadPlug> */}
				<Container style={{ marginTop: 60 }}>
					<Row>
						<Col>
							<p style={{ color: constants.primaryETAButtonColor }}><strong>{moment(this.props.article.created_at).format('ddd MMM Do')}</strong></p>
							{this.getVideo()}
							<div style={{ maxWidth: deviceInfo.isMobile ? null : '800px' }}>
								<ReactMarkdown source={source}
									parserOptions={{ commonmark: true }}
									renderers={{ image: this.Image }}
								/>
							</div>
							<NoSSR>
							<Button id="shareButton" variant="outline-dark" data-clipboard-text={`https://www.witheta.com/blog/${this.props.article.id}`} onClick={() => this.handleShare()} style={{marginBottom: 20}}>Share <FiShare></FiShare></Button>
							</NoSSR>
						</Col>
						{/* <Col md>
							<p>ETA is the experience platform for the culture. </p>
							</Col> */}
					</Row>


					<div style={{ marginTop: 60 }}>
						<h3 style={{marginBottom: 20}}>Other guides to read!</h3>

						{this.props.otherArticles && this.props.otherArticles.map((item) => <a href={`/blog/${item.id}`} style={{ color: 'black' }}><Row style={{ marginBottom: 10, width: null }}>
							<Col md style={{}}>
								<div style={{ backgroundImage: `url(${item.image_url})`, width: '100%', height: '200px', backgroundPosition: 'center', backgroundSize: 'cover' }}>
								</div>
							</Col>
							<Col md style={{ paddingTop: 20, marginBottom: 10 }}>
								<h4>{item.title}</h4>
							</Col>
						</Row></a>)}
					</div>
				</Container>
				<style global jsx>{`
					p, h1, h2, h3, h4, h5 {
						font-family: Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif !important;
						color: #333 !important;
					}

				`}</style>
			</Layout>
		)
	}
}


// {
// 	"venue": {
// 	  "type": "RECT",
// 	  "position": {
// 		"x": -46.458239180328434,
// 		"y": -90.4419452418137,
// 		"z": 65.82980447249908
// 	  },
// 	  "url": "https://spaces-public-production.s3.us-east-2.amazonaws.com/spaces/vr_gallery_curved_concrete.glb",
// 	  "media_type": "mesh",
// 	  "scale": {
// 		"x": 0.05,
// 		"y": 0.08,
// 		"z": 0.05
// 	  },
// 	  "subtype": "venue",
// 	  "layer": 0,
// 	  "id": "venue",
// 	  "imported": true,
// 	  "rotation": {
// 		"x": 0,
// 		"y": 0,
// 		"z": 0
// 	  },
// 	  "name": "",
// 	  "label": ""
// 	},
// 	"poster": {
// 	  "type": "RECT",
// 	  "position": {
// 		"x": 77,
// 		"y": 8,
// 		"z": 142
// 	  },
// 	  "rotation": {
// 		"x": 0,
// 		"y": 4.72,
// 		"z": 0
// 	  },
// 	  "width": 70,
// 	  "height": 35,
// 	  "subtype": "screenshare",
// 	  "layer": 1,
// 	  "id": "poster",
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "name": "",
// 	  "label": ""
// 	},
// 	"poster_1": {
// 		"type": "RECT",
// 		"position": {
// 			"x": -69.70880408005887,
// 			"y": -72.39195175915955,
// 			"z": 64.81
// 		  },
// 		"rotation": {
// 		  "x": 0,
// 		  "y": -9.46,
// 		  "z": 0
// 		},
// 		"width": 70,
// 		"media_type": "video",
// 		"height": 35,
// 		"layer": 1,
// 		"id": "poster_1",
// 		"scale": {
// 		  "x": 1,
// 		  "y": 1,
// 		  "z": 1
// 		},
// 		"url": "https://spaces-public-production.s3.us-east-2.amazonaws.com/assets/yt5s.com-Wanda+Maximoff+__+Rise-(1080p).mp4"
// 	  },
// 	"image_1": {
// 	  "type": "RECT",
// 	  "id": "image_1",
// 	  "position": {
// 		"x": -100.089,
// 		"y": -80.39195175915955,
// 		"z": 33.43
// 	  },
// 	  "media_type": "image",
// 	  "layer": 1,
// 	  "width": 20,
// 	  "height": 13,
// 	  "placeholder": true,
// 	  "rotation": {
// 		"x": 0,
// 		"y": -4.71574623524393,
// 		"z": 0
// 	  },
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "label": "olive the briny",
// 	   "url": "https://lh3.googleusercontent.com/lkWKbQfbE9lNkyo-aGrVu8LEG6c5z27Q3wv5e_bNolTmAoI-5qfzPG8Zw2oizilCdzDOmd5QeRxYkEWxsb9V7GYbCKwvKIUhvGa-McA=w600",
// 	  "link": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/8994",
// 	  "name": "",
// 	  "metadata": {
// 		"name": "olive the briny",
// 		"image_preview_url": "https://lh3.googleusercontent.com/lkWKbQfbE9lNkyo-aGrVu8LEG6c5z27Q3wv5e_bNolTmAoI-5qfzPG8Zw2oizilCdzDOmd5QeRxYkEWxsb9V7GYbCKwvKIUhvGa-McA=w600",
// 		"description": "-",
// 		"permalink": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/8994"
// 	  }
// 	},
// 	"image_2": {
// 	  "type": "RECT",
// 	  "id": "image_2",
// 	  "position": {
// 		"x": -100,
// 		"y": -80.392,
// 		"z": 12.161
// 	  },
// 	  "media_type": "image",
// 	  "layer": 1,
// 	  "width": 14,
// 	  "height": 12,
// 	  "placeholder": true,
// 	  "rotation": {
// 		"x": 0,
// 		"y": 1.5707963267948966,
// 		"z": 0
// 	  },
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "label": "oizys",
// 	  "url": "https://lh3.googleusercontent.com/T3R3CPViXucwB97W_2bJyGuMUS1-e0Qdx85tAaDnPcXBvR53eLVx7qIXH-pHk2U7SOqeqzY7m_GB16oOSfKKuPFC1FyIAWA1XZqfqQ=w600",
// 	 "link": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/9759",
// 	 "name": "",
// 	 "metadata": {
// 	   "name": "oizys",
// 	   "image_preview_url": "https://lh3.googleusercontent.com/T3R3CPViXucwB97W_2bJyGuMUS1-e0Qdx85tAaDnPcXBvR53eLVx7qIXH-pHk2U7SOqeqzY7m_GB16oOSfKKuPFC1FyIAWA1XZqfqQ=w600",
// 	   "description": "You are a WITCH made of wretchedness and worry. You collect cries of misery like pearls on a string. Your magic spawns from the suffering of the hapless. You linger wherever there are shadows of distress to darken. ALL FEAR THE CALAMITY OF YOUR WRATH!",
// 	   "permalink": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/9759"
// 	 }
// 	},
// 	"image_3": {
// 	  "type": "RECT",
// 	  "id": "image_3",
// 	  "placeholder": true,
// 	  "position": {
// 		"x": -47.081,
// 		"y": -80.39195175170897,
// 		"z": 24.519860732372237
// 	  },
// 	  "media_type": "image",
// 	  "layer": 1,
// 	  "width": 14,
// 	  "height": 10,
// 	  "rotation": {
// 		"x": 0,
// 		"y": 4.71238898038469,
// 		"z": 0
// 	  },
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "label": "Muria The Mad",
// 	  "url": "https://lh3.googleusercontent.com/LhaL1WBHv0wHO3Vs-b6HtYwarVt8eJQhg8lNfisUGuCUlkDJeID8wV7X10R2ulVfoLawQYxga1kNrROQZ-vcWhw4QrNFJBtBKQ3OVfE=w600",
// 	  "link": "https://www.cryptocoven.xyz/witches/1388",
// 	  "name": "",
// 	  "metadata": {
// 		"name": "Muria The Mad",
// 		"image_preview_url": "https://lh3.googleusercontent.com/LhaL1WBHv0wHO3Vs-b6HtYwarVt8eJQhg8lNfisUGuCUlkDJeID8wV7X10R2ulVfoLawQYxga1kNrROQZ-vcWhw4QrNFJBtBKQ3OVfE=w600",
// 		"description": "You are a WITCH made of sunshine. You make your own jewelry from beads and stars. Your magic spawns from sparks of flame. The other servants of nature are ever suspicious of your mastery of chaos. CRAFT MAKEUP FROM THE EARTH!",
// 		"permalink": "https://www.cryptocoven.xyz/witches/1388"
// 	  }
// 	},
// 	"image_4": {
// 	  "type": "RECT",
// 	  "id": "image_4",
// 	  "placeholder": true,
// 	  "position": {
// 		"x": -47.027,
// 		"y": -80.392,
// 		"z": -12.602
// 	  },
// 	  "media_type": "image",
// 	  "layer": 1,
// 	  "width": 10,
// 	  "height": 10,
// 	  "rotation": {
// 		"x": 0,
// 		"y": 4.71238898038469,
// 		"z": 0
// 	  },
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "label": "enthea",
// 	  "url": "https://lh3.googleusercontent.com/S2ucUsVUu4ilDNqiCpHJib1PGFneQHM2bnoeAoJsI0u5y4NlggrsFO6G0KR8ADLuk3Zd9eRdeAIC4CZigDlHLfN4EncHfXETa7t9bg=w600",
// 	  "link": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/9758",
// 	  "name": "",
// 	  "metadata": {
// 	   "name": "enthea",
// 	   "image_preview_url": "https://lh3.googleusercontent.com/S2ucUsVUu4ilDNqiCpHJib1PGFneQHM2bnoeAoJsI0u5y4NlggrsFO6G0KR8ADLuk3Zd9eRdeAIC4CZigDlHLfN4EncHfXETa7t9bg=w600",
// 	   "description": "You are a WITCH made of life fermenting. You find music in all things — sea foam and swallows, storms and snap peas. Your magic spawns from whiskey, hops, and the mother of yeasts. Your garden of psychedelics is attended by all creatures who call themselves friend. THE HEAT OF CREATION IS SWADDLED IN YOUR HANDS!",
// 	   "permalink": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/9758"
// 	  }
// 	},
// 	"image_5": {
// 	  "type": "RECT",
// 	  "id": "image_5",
// 	  "placeholder": true,
// 	  "position": {
// 		"x": -85.959,
// 		"y": -80.39195175170897,
// 		"z": -41.5
// 	  },
// 	  "media_type": "image",
// 	  "layer": 1,
// 	  "width": 14,
// 	  "height": 12,
// 	  "rotation": {
// 		"x": 0,
// 		"y": 0,
// 		"z": 0
// 	  },
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "label": "hazel tide",
// 	  "url": "https://lh3.googleusercontent.com/w_wsqNWowcE-aQ1GQ4KvrvGk8X9Clxht7fpxSOpoL4kANm47xzmn2Fy4pBHkxwNetSq3_lkLdkZMP_gikHrEcoyrrFX6qRjz703B_g=w600",
// 	  "link": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/8150",
// 	  "name": "",
// 	  "metadata": {
// 	   "name": "hazel tide",
// 	   "image_preview_url": "https://lh3.googleusercontent.com/w_wsqNWowcE-aQ1GQ4KvrvGk8X9Clxht7fpxSOpoL4kANm47xzmn2Fy4pBHkxwNetSq3_lkLdkZMP_gikHrEcoyrrFX6qRjz703B_g=w600",
// 	   "description": "You are a WITCH made of feathers and forsythia. You whisper your secrets to mummified heads. Your magic spawns from the warmth of a good book with ten very attractive people on the cover. The cards speak to you in the voices of your enemies. FILL YOUR MIND WITH INCANTATIONS!",
// 	   "permalink": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/8150"
// 	  }
// 	},
// 	"image_6": {
// 	  "type": "RECT",
// 	  "id": "image_6",
// 	  "placeholder": true,
// 	  "position": {
// 		"x": -60.95907203857292,
// 		"y": -80.39195175170897,
// 		"z": -41.5
// 	  },
// 	  "media_type": "image",
// 	  "layer": 1,
// 	  "width": 14,
// 	  "height": 12,
// 	  "rotation": {
// 		"x": 0,
// 		"y": 0,
// 		"z": 0
// 	  },
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "label": "mademoiselle oboe",
// 	  "url": "https://lh3.googleusercontent.com/euLKlWuKWugIVqQnAiO3vWmaddrGf2U190LF02TeF4KEmr4mGTibJR239uC27L553qcGfJpNpbR8os1iUublE4KOlo8Q_5SErPYksg=w600",
// 	  "link": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/5973",
// 	  "name": "",
// 	  "metadata": {
// 	   "name": "mademoiselle oboe",
// 	   "image_preview_url": "https://lh3.googleusercontent.com/euLKlWuKWugIVqQnAiO3vWmaddrGf2U190LF02TeF4KEmr4mGTibJR239uC27L553qcGfJpNpbR8os1iUublE4KOlo8Q_5SErPYksg=w600",
// 	   "description": "You are a WITCH carved from a jack-o-lantern. You are an explorer of the far-flung unknown, a messenger from the edge. Your magic spawns from a cloud of pepper spray. You cast illusions as you sing to lovers, words drizzling from your lips like honey. HIKE UP YOUR SKIRT AND TRAMPLE!",
// 	   "permalink": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/5973"
// 	  }
// 	},
// 	"image_7": {
// 	  "type": "RECT",
// 	  "id": "image_7",
// 	  "position": {
// 		"x": -100.053,
// 		"y": -80.392,
// 		"z": -10.161
// 	  },
// 	  "media_type": "image",
// 	  "layer": 1,
// 	  "width": 14,
// 	  "height": 12,
// 	  "placeholder": true,
// 	  "rotation": {
// 		"x": 0,
// 		"y": 1.5707963267948966,
// 		"z": 0
// 	  },
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "label": "alizarin dagger",
// 	  "url": "https://lh3.googleusercontent.com/HyCzBuZDBuU7Cjt49bi7CAZZUyciKihgSMR3WdovBzp3_NWQVNA1WH4y2lKRqnrDq0GWiy4jmgWDvQdPfQ88JpbkCMfsg73cHpcLZHg=w600",
// 	  "link": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/5940",
// 	  "name": "",
// 	  "metadata": {
// 	   "name": "alizarin dagger",
// 	   "image_preview_url": "https://lh3.googleusercontent.com/HyCzBuZDBuU7Cjt49bi7CAZZUyciKihgSMR3WdovBzp3_NWQVNA1WH4y2lKRqnrDq0GWiy4jmgWDvQdPfQ88JpbkCMfsg73cHpcLZHg=w600",
// 	   "description": "You are a WITCH who sleeps on ice. You are a guardian of all that is good. Your magic spawns from a fawn’s first steps. You can chill the very marrow of an enemy's bones. WALK BACKWARDS INTO THE SUN!",
// 	   "permalink": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/5940"
// 	  }
// 	},
// 	"image_8": {
// 	  "type": "RECT",
// 	  "id": "image_8",
// 	  "position": {
// 		"x": -100.053,
// 		"y": -80.392,
// 		"z": -28.161
// 	  },
// 	  "media_type": "image",
// 	  "layer": 1,
// 	  "width": 14,
// 	  "height": 12,
// 	  "placeholder": true,
// 	  "rotation": {
// 		"x": 0,
// 		"y": 1.5707963267948966,
// 		"z": 0
// 	  },
// 	  "scale": {
// 		"x": 1,
// 		"y": 1,
// 		"z": 1
// 	  },
// 	  "label": "pine, the absolute hood",
// 	  "url": "https://lh3.googleusercontent.com/gnWlH5s_f5GJqtt0c_xfcoXxuxEUIeLIH7UbHVjteB1959uNY5ljR26uGoEjm6UPkOnCDfxYgbuqECGs3YQKinCSTCUXdm6S3AYK85M=w600",
// 	  "link": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/7881",
// 	  "name": "",
// 	  "metadata": {
// 	   "name": "pine, the absolute hood",
// 	   "image_preview_url": "https://lh3.googleusercontent.com/gnWlH5s_f5GJqtt0c_xfcoXxuxEUIeLIH7UbHVjteB1959uNY5ljR26uGoEjm6UPkOnCDfxYgbuqECGs3YQKinCSTCUXdm6S3AYK85M=w600",
// 	   "description": "You are a WITCH who runneth over with ichor and honey. You collect things, all things — stamps and spores, tree nuts and entrails. Your magic spawns from laughing at your own jokes. Your lawn is crowded with the dances of the dead. HARK!",
// 	   "permalink": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/7881"
// 	  }
// 	},
// 	"image_9": {
// 		"type": "RECT",
// 		"id": "image_8",
// 		"position": {
// 		  "x": -100.053,
// 		  "y": -80.392,
// 		  "z": -28.161
// 		},
// 		"media_type": "image",
// 		"layer": 1,
// 		"width": 14,
// 		"height": 12,
// 		"placeholder": true,
// 		"rotation": {
// 		  "x": 0,
// 		  "y": 1.5707963267948966,
// 		  "z": 0
// 		},
// 		"scale": {
// 		  "x": 1,
// 		  "y": 1,
// 		  "z": 1
// 		},
// 		"label": "pine, the absolute hood",
// 		"url": "https://lh3.googleusercontent.com/gnWlH5s_f5GJqtt0c_xfcoXxuxEUIeLIH7UbHVjteB1959uNY5ljR26uGoEjm6UPkOnCDfxYgbuqECGs3YQKinCSTCUXdm6S3AYK85M=w600",
// 		"link": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/7881",
// 		"name": "",
// 		"metadata": {
// 		 "name": "pine, the absolute hood",
// 		 "image_preview_url": "https://lh3.googleusercontent.com/gnWlH5s_f5GJqtt0c_xfcoXxuxEUIeLIH7UbHVjteB1959uNY5ljR26uGoEjm6UPkOnCDfxYgbuqECGs3YQKinCSTCUXdm6S3AYK85M=w600",
// 		 "description": "You are a WITCH who runneth over with ichor and honey. You collect things, all things — stamps and spores, tree nuts and entrails. Your magic spawns from laughing at your own jokes. Your lawn is crowded with the dances of the dead. HARK!",
// 		 "permalink": "https://opensea.io/assets/0x5180db8f5c931aae63c74266b211f580155ecac8/7881"
// 		}
// 	},
// 	"default_spawn": {
// 	  "type": "SPAWN",
// 	  "position": {
// 		"x": -51.2160030309649,
// 		"y": -80.39195175170897,
// 		"z": 60.353186271201544
// 	  },
// 	  "rotation": {
// 		"x": 0.008029101562499998,
// 		"y": -2.36139908195303,
// 		"z": 0
// 	  },
// 	  "id": "default_spawn",
// 	  "name": "",
// 	  "label": ""
// 	}
//   }